"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.number.constructor.js");

var _react = _interopRequireWildcard(require("react"));

var _ol = require("ol");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Group = _interopRequireDefault(require("ol/layer/Group"));

var _TreeLayerContextMenu = _interopRequireDefault(require("../../../contextMenu/TreeLayerContextMenu/TreeLayerContextMenu"));

var _map = require("../../../../util/map");

var _useTreeContextMenu2 = _interopRequireDefault(require("../../../../hooks/ui/useTreeContextMenu"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * <p>Tree to show the layers in a layer group. This component
 * presents several functionalities:</p>
 * <ol>
 * <li>The user will be able to switch the layer visibility to on/off
 * using the checkbox control.</li>
 * <li>Re-order the layers using the drag/drop functionality.</li>
 * <li>If the user right click the mouse in a layer node, a context
 * menu will be shown to provide several possibilities to 
 * interact with layer (create a  new layer, edit, remove, etc...)</li>
 * </ol>
 * @visibleName Layer Tree
 */
var LayerTree = function LayerTree(_ref) {
  var map = _ref.map,
      _ref$layerGroup = _ref.layerGroup,
      layerGroup = _ref$layerGroup === void 0 ? map.getLayerGroup() : _ref$layerGroup,
      _ref$draggable = _ref.draggable,
      draggable = _ref$draggable === void 0 ? true : _ref$draggable,
      _ref$checkable = _ref.checkable,
      checkable = _ref$checkable === void 0 ? true : _ref$checkable,
      _ref$onExpand = _ref.onExpand,
      onExpand = _ref$onExpand === void 0 ? false : _ref$onExpand,
      _ref$filterFunc = _ref.filterFunc,
      filterFunc = _ref$filterFunc === void 0 ? null : _ref$filterFunc,
      _ref$titleFunc = _ref.titleFunc,
      titleFunc = _ref$titleFunc === void 0 ? null : _ref$titleFunc;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      treeNodes = _useState2[0],
      setTreeNodes = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      checkedKeys = _useState4[0],
      setCheckedKeys = _useState4[1]; //const [rightClickedNode, setRightClickedNode] = useState(null);
  //const [showMenuContext, setShowMenuContext] = useState(false);


  var _useTreeContextMenu = (0, _useTreeContextMenu2.default)(),
      xPos = _useTreeContextMenu.xPos,
      yPos = _useTreeContextMenu.yPos,
      showMenu = _useTreeContextMenu.showMenu,
      rightClickedNode = _useTreeContextMenu.rightClickedNode,
      onRightClickNode = _useTreeContextMenu.onRightClickNode;

  var rootLayerName = null;

  if (!map.getLayerGroup().get('name')) {
    rootLayerName = 'Layers';
    map.getLayerGroup().set('name', rootLayerName);
  } else {
    rootLayerName = map.getLayerGroup().get('name');
  }
  /*
  const onRightClickNode = useCallback((event) => {
      setRightClickedNode(event.node);
      setShowMenuContext(true);
  }, []);
  */

  /*
  const onFinishMenuContext = useCallback(() => {
      setShowMenuContext(false);
      setRightClickedNode(null);
  }, []);
  */

  /**
   * Get the flat array of ol_uids from visible non groupLayers.
   *
   * @return The visible ol_uids.
   */


  var getVisibleOlUids = (0, _react.useCallback)(function () {
    var layers = (0, _map.getAllLayers)(layerGroup, function (layer) {
      return !(layer instanceof _Group.default) && layer.getVisible();
    });
    layers = filterFunc ? layers.filter(filterFunc) : layers;
    return layers.map(function (l) {
      return l.ol_uid.toString();
    });
  }, [filterFunc, layerGroup]);
  /**
   * Creates a treeNode for the input layer.
   * 
   * @param {ol.layer.Base} layer 
   * @return The corresponding LayerTreeNode element.
   */

  var treeNodeFromLayer = (0, _react.useCallback)(function (layer) {
    var childNodes = [];

    if (layer instanceof _Group.default) {
      var childLayers = layer.getLayers().getArray();
      childLayers = filterFunc ? childLayers.filter(filterFunc) : childLayers;
      childNodes = childLayers.map(function (childLayer) {
        return treeNodeFromLayer(childLayer);
      });
      childNodes.reverse();
    }

    var treeNode = /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tree.TreeNode, {
      title: titleFunc ? titleFunc(layer) : layer.get('name'),
      ol_layer: layer,
      children: childNodes.length > 0 && childNodes
    }, layer.ol_uid.toString()); //treeNode._ol_layer = layer;

    return treeNode;
  }, [filterFunc, titleFunc]);
  /**
   * Creates TreeNodes from a given layergroup and sets the treeNodes in the state.
   * 
   * @param {ol.layer.Group} groupLayer A Layer Group
   */

  var treeNodesFromLayerGroup = (0, _react.useCallback)(function (groupLayer) {
    var layers = groupLayer.getLayers().getArray();
    layers = filterFunc ? layers.filter(filterFunc) : layers;
    var newTreeNodes = layers.map(function (layer) {
      return treeNodeFromLayer(layer);
    });
    newTreeNodes.reverse();
    setTreeNodes(newTreeNodes);
  }, [filterFunc, treeNodeFromLayer]);
  /**
   * 
   * @param {ol.MapEvent} evt 
   */

  var rebuildTreeNodes = (0, _react.useCallback)(function (evt) {
    treeNodesFromLayerGroup(layerGroup);
    setCheckedKeys(getVisibleOlUids());
  }, [layerGroup, getVisibleOlUids, treeNodesFromLayerGroup]);
  /**
   * Event Handler to handle 'change:name' event
   * 
   */

  var onLayerChangeName = (0, _react.useCallback)(function (evt) {
    if (evt.target.get('name') !== evt.oldValue) {
      rebuildTreeNodes();
    }
  }, [rebuildTreeNodes]);
  /**
   * Register the 'change:name' event handler for the layer.
   * if the layer is a group, the related children will have 
   * also the event handler registered.
   * 
   * @param {ol.layer.Base} layerOrGroup A corresponding layer or group
   */

  var registerOnLayerChangeName = (0, _react.useCallback)(function (layerOrGroup) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (layerOrGroup instanceof _Group.default) {
      //register layer group
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.on('change:name', onLayerChangeName);
      } //register childrens


      var layers = layerOrGroup.getLayers();
      layers.forEach(function (layer) {
        if (filterFunction(layer)) {
          registerOnLayerChangeName(layer);
        }
      });
    } else {
      //register leaf
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.on('change:name', onLayerChangeName);
      }
    }
  }, [filterFunc, onLayerChangeName]);
  /**
   * Unregister the 'change:name' event handler for the layer.
   * if the layer is a group, the related children will have 
   * also the event handler unregistered.
   * 
   * @param {ol.layer.Base} layerOrGroup A corresponding layer or group
   */

  var unRegisterOnLayerChangeName = (0, _react.useCallback)(function (layerOrGroup) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (layerOrGroup instanceof _Group.default) {
      //unregister layer group
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.un('change:name', onLayerChangeName);
      } //register childrens


      var layers = layerOrGroup.getLayers();
      layers.forEach(function (layer) {
        if (filterFunction(layer)) {
          unRegisterOnLayerChangeName(layer);
        }
      });
    } else {
      //register leaf
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.un('change:name', onLayerChangeName);
      }
    }
  }, [filterFunc, onLayerChangeName]);
  /**
    * Event handler to react to 'change:visible' event
    * 
    * @param {*} evt 
    */

  var onLayerChangeVisible = (0, _react.useCallback)(function (evt) {
    var newCheckedKeys = getVisibleOlUids();
    setCheckedKeys(newCheckedKeys);
    rebuildTreeNodes();
  }, [getVisibleOlUids, rebuildTreeNodes]);
  /**
   * Register the 'change:visible' event handler for the layer.
   * if the layer is a group, the related children will have 
   * also the event handler registered.
   * 
   * @param {ol.layer.Base} layerOrGroup A corresponding layer or group
   */

  var registerOnLayerChangeVisible = (0, _react.useCallback)(function (layerOrGroup) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (layerOrGroup instanceof _Group.default) {
      //register layer group
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.on('change:visible', onLayerChangeVisible);
      } //register childrens


      var layers = layerOrGroup.getLayers();
      layers.forEach(function (layer) {
        if (filterFunction(layer)) {
          registerOnLayerChangeVisible(layer);
        }
      });
    } else {
      //register leaf
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.on('change:visible', onLayerChangeVisible);
      }
    }
  }, [filterFunc, onLayerChangeVisible]);
  /**
   * Unregister the 'change:visible' event handler for the layer.
   * if the layer is a group, the related children will have 
   * also the event handler unregistered.
   * 
   * @param {ol.layer.Base} layerOrGroup A corresponding layer or group
   */

  var unRegisterOnLayerChangeVisible = (0, _react.useCallback)(function (layerOrGroup) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (layerOrGroup instanceof _Group.default) {
      //unregister layer group
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.un('change:visible', onLayerChangeVisible);
      } //register childrens


      var layers = layerOrGroup.getLayers();
      layers.forEach(function (layer) {
        if (filterFunction(layer)) {
          unRegisterOnLayerChangeVisible(layer);
        }
      });
    } else {
      //register leaf
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.un('change:visible', onLayerChangeVisible);
      }
    }
  }, [filterFunc, onLayerChangeVisible]);
  /**
   * Register recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * Pre-definition of registerCollectionHandlers to manage circular
   * dependencies. See re-definition below
   */

  var registerCollectionHandlers = null;
  /**
   * Unregister recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * Pre-definition of unRegisterCollectionHandlers to manage circular
   * dependencies. See re-definition below
   */

  var unRegisterCollectionHandlers = null;
  /**
   * Event handler called once a layer is added
   * to the collection.
   * 
   * This handler will register:
   * (a) the event handlers for add/remove/change in group layer
   * (b) the 'change:visible' event handler for the layer.
   */

  var onCollectionAdd = (0, _react.useCallback)(function (evt) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (filterFunction(evt.element)) {
      if (evt.element instanceof _Group.default) {
        registerCollectionHandlers && registerCollectionHandlers(evt.element);
      }

      registerOnLayerChangeVisible(evt.element);
      registerOnLayerChangeName(evt.element);
    }

    rebuildTreeNodes();
  }, [registerCollectionHandlers, registerOnLayerChangeVisible, registerOnLayerChangeName, filterFunc, rebuildTreeNodes]);
  /**
   * Event handler called once a layer is removed
   * from the collection.
   * 
   * This handler will unregister:
   * (a) the event handlers for add/remove/change in group layer
   * (b) the 'change:visible' event handler for the layer.
   */

  var onCollectionRemove = (0, _react.useCallback)(function (evt) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (filterFunction(evt.element)) {
      if (evt.element instanceof _Group.default) {
        unRegisterCollectionHandlers && unRegisterCollectionHandlers(evt.element);
      }

      unRegisterOnLayerChangeVisible(evt.element);
      unRegisterOnLayerChangeName(evt.element);
    }

    rebuildTreeNodes();
  }, [unRegisterCollectionHandlers, unRegisterOnLayerChangeVisible, filterFunc, rebuildTreeNodes, unRegisterOnLayerChangeName]);
  var onCollectionChangeLayers = (0, _react.useCallback)(function (evt) {//const filterFunc = filterFunc ? filterFunc : () => true;
    //TODO: Needed to handle???
  }, []);
  /**
   * Register recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * @param {ol.layer.Group} groupLayer 
   */

  registerCollectionHandlers = (0, _react.useCallback)(function (groupLayer) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };
    var collection = groupLayer.getLayers();

    if (filterFunction(groupLayer)) {
      collection.on('add', onCollectionAdd);
      collection.on('remove', onCollectionRemove);
      groupLayer.on('change:layers', onCollectionChangeLayers);
    } //register handler in all the child group layers


    collection.forEach(function (layer) {
      if (layer instanceof _Group.default) {
        registerCollectionHandlers(layer);
      }
    });
  }, [filterFunc, onCollectionAdd, onCollectionRemove, onCollectionChangeLayers, registerCollectionHandlers]);
  /**
   * Unregister recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * @param {ol.layer.Group} groupLayer 
   */

  unRegisterCollectionHandlers = (0, _react.useCallback)(function (groupLayer) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };
    var collection = groupLayer.getLayers();

    if (filterFunction(groupLayer)) {
      collection.un('add', onCollectionAdd);
      collection.un('remove', onCollectionRemove);
      groupLayer.un('change:layers', onCollectionChangeLayers);
    } //register handler in all the child group layers


    collection.forEach(function (layer) {
      if (layer instanceof _Group.default) {
        unRegisterCollectionHandlers(layer);
      }
    });
  }, [filterFunc, onCollectionAdd, onCollectionRemove, onCollectionChangeLayers, unRegisterCollectionHandlers]);
  /**
   * Sets the layer visibility. Calls itself
   * recursively for group layers.
   * 
   * @param {ol.layer.Base} layer 
   * @param {boolean} visibility 
   */

  var setLayerVisibility = (0, _react.useCallback)(function (layer, visibility) {
    if (layer instanceof _Group.default) {
      layer.getLayers().forEach(function (subLayer) {
        setLayerVisibility(subLayer, visibility);
      });
    } else {
      if (layer) {
        layer.setVisible(visibility);
      }
    }
  }, []);
  /**
   * Callback Method to be called once the check box is
   * checked in the tree view.
   * @param {Array(string)} checkedKeys 
   * @param {{checked:bool}} e 
   */

  var onCheck = (0, _react.useCallback)(function (checkedKeys, e) {
    var checked = e.checked; //const key = e.node.key;
    //const layer = getLayerByOlUid(map, key);

    var layer = e.node.ol_layer;
    setLayerVisibility(layer, checked);
  }, [setLayerVisibility]);
  /**
   * The callback method for the drop event in the tree view.
   * As result, the corresponding layers will be re-ordered in the 
   * map and in the tree.
   * 
   * @param e The ant-d tree event object for this event. See ant-d docs
   */

  var onDrop = (0, _react.useCallback)(function (e) {
    //const dragLayer = getLayerByOlUid(map, e.dragNode.key);
    var dragLayer = e.dragNode.ol_layer;
    var dragInfo = (0, _map.getLayerPositionInfo)(dragLayer, map);
    var dragCollection = dragInfo.groupLayer.getLayers();
    var dropLayer = e.node.ol_layer;
    var dropPos = e.node.pos.split('-');
    var location = e.dropPosition - Number(dropPos[dropPos.length - 1]);
    dragCollection.remove(dragLayer);
    var dropInfo = (0, _map.getLayerPositionInfo)(dropLayer, map);
    var dropPosition = dropInfo.position;
    var dropCollection = dropInfo.groupLayer.getLayers(); // drop before node

    if (location === -1) {
      if (dropPosition === dropCollection.getLength() - 1) {
        dropCollection.push(dragLayer);
      } else {
        dropCollection.insertAt(dropPosition + 1, dragLayer);
      } // drop on node

    } else if (location === 0) {
      if (dropLayer instanceof _Group.default) {
        dropLayer.getLayers().push(dragLayer);
      } else {
        dropCollection.insertAt(dropPosition + 1, dragLayer);
      } // drop after node

    } else if (location === 1) {
      dropCollection.insertAt(dropPosition, dragLayer);
    }

    rebuildTreeNodes();
  }, [map, rebuildTreeNodes]);
  /**
   * The callback method to be called after the tree
   * is expanded.
   * This method will call rebuildTreeNodes to avoid
   * sync issues.
   * 
   * @param {string[]} expandedKeys The expanded keys
   * @param {Object} info The info about the expanded keys.
   *                      check ant-d doc for more details
   */

  var onExpandTree = (0, _react.useCallback)(function (expandedKeys, info) {
    rebuildTreeNodes();

    if (onExpand) {
      onExpandTree(expandedKeys, info);
    }
  }, [onExpand, rebuildTreeNodes]);
  /**
   * Register 'change:visible' for the group layer and all its
   * childrens
   */

  (0, _react.useEffect)(function () {
    registerOnLayerChangeVisible(layerGroup); //clean-up:

    return function () {
      return unRegisterOnLayerChangeVisible(layerGroup);
    };
  }, [layerGroup, registerOnLayerChangeVisible, unRegisterOnLayerChangeVisible]);
  /**
   * Register 'change:name' for the group layer and all its
   * childrens
   */

  (0, _react.useEffect)(function () {
    registerOnLayerChangeName(layerGroup); //clean-up:

    return function () {
      return unRegisterOnLayerChangeName(layerGroup);
    };
  }, [layerGroup, registerOnLayerChangeName, unRegisterOnLayerChangeName]);
  /**
   * Register collection event handlers for the group layer and 
   * its child group layers 
   */

  (0, _react.useEffect)(function () {
    registerCollectionHandlers(layerGroup); //clean-up:

    return function () {
      return unRegisterCollectionHandlers(layerGroup);
    };
  }, [layerGroup, registerCollectionHandlers, unRegisterCollectionHandlers]);
  /**
   * rebuild the tree nodes
   */

  (0, _react.useEffect)(function () {
    rebuildTreeNodes();
  }, [rebuildTreeNodes]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tree, {
      checkedKeys: checkedKeys,
      draggable: draggable,
      checkable: checkable //showLine
      ,
      onCheck: onCheck,
      onDrop: onDrop,
      onExpand: onExpandTree,
      onRightClick: onRightClickNode,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tree.TreeNode, {
        title: rootLayerName,
        ol_layer: map.getLayerGroup(),
        children: treeNodes
      }, "root")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TreeLayerContextMenu.default, {
      map: map,
      node: rightClickedNode,
      xPos: xPos,
      yPos: yPos,
      showMenu: showMenu
    })]
  });
};

LayerTree.propTypes = {
  /**
   * The OpenLayers ol/Map having the layers to be shown
   * in the TreeLayer.
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * The OpenLayers ol/layer/Group having the layers to be shown
   * in the TreeLayer.
   * If not provided, all the layers from the <u>map</u> will
   * be shown.
   */
  layerGroup: _propTypes.default.instanceOf(_Group.default),

  /**
   * If true, the user can re-order the layers through the
   * drag/drop in the LayerTree.
   */
  draggable: _propTypes.default.bool,

  /**
   * If true, the user will be able to switch the layer visibility
   * on/off for the layer using the check-box control in the TreeLayer.
   */
  checkable: _propTypes.default.bool,

  /**
   * Function to filter the layers to be shown in the TreeLayer.
   * This function should have as parameter the layer and if it 
   * returns true, the layer will be shown; otherwise the layer
   * will not be included in the TreeLayer. Check for the
   * javascript Array.filter function for additional parameters.
   * If not provided, all the layers present in the 
   * <u>layerGroup</u> will be shown.
   */
  filterFunc: _propTypes.default.func,

  /**
   * A function to change the title of the Layer to be shown
   * in the TreeLayer. This function will receive as parameter
   * the layer and returns a string for the title. Some function
   * implementations should be, for example, to set the first 
   * letter of the layer name in uppercase and or to replace
   * "_" by a single space. This function will not change the layer
   * name and it will only affect how the layer name will be 
   * shown in the TreeLayer.
   */
  titleFunc: _propTypes.default.func
};
var _default = LayerTree;
exports.default = _default;